import type { UsuarioSessao } from "@ydchat/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { useState, type FormEvent } from "react";
import { Botao } from "@/components/ui/botao";
import { Campo } from "@/components/ui/campo";
import { api, ErroApi } from "@/lib/api";
import { chaveSessao } from "@/lib/sessao";

export function TelaLogin() {
  const qc = useQueryClient();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const entrar = useMutation({
    mutationFn: () => api.post<UsuarioSessao>("/auth/login", { email, senha }),
    onSuccess: (u) => qc.setQueryData(chaveSessao, u),
  });

  const enviar = (e: FormEvent) => {
    e.preventDefault();
    entrar.mutate();
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gradient-to-b from-gold-200 to-white px-4">
      <form
        onSubmit={enviar}
        className="w-full max-w-sm space-y-5 rounded-xl border border-neutral-200 bg-white p-6 shadow-md sm:p-8"
      >
        <div className="flex flex-col items-center gap-3 pb-2">
          <img src="/logo-yourdress-wordmark.png" alt="YourDress" className="h-9 object-contain" />
          <p className="text-sm text-neutral-500">Central de atendimento</p>
        </div>
        <label className="block space-y-1.5">
          <span className="text-sm font-semibold text-neutral-800">E-mail</span>
          <Campo
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label className="block space-y-1.5">
          <span className="text-sm font-semibold text-neutral-800">Senha</span>
          <Campo
            type="password"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </label>
        {entrar.error && (
          <p role="alert" className="rounded-md bg-danger-100 px-3 py-2 text-sm text-danger-500">
            {entrar.error instanceof ErroApi ? entrar.error.message : "Não foi possível entrar."}
          </p>
        )}
        <Botao type="submit" className="w-full justify-center" disabled={entrar.isPending}>
          {entrar.isPending && <Loader2 size={16} className="animate-spin" />}
          Entrar
        </Botao>
      </form>
    </div>
  );
}
